const css = `.CRWCUq__selectorPart:hover{outline:1px solid var(--base-surfaces-hover-opaque);outline-offset:1px}.CRWCUq__pill{cursor:pointer;transition:all .3s ease-in-out}.CRWCUq__active{border:1px solid #0000}.CRWCUq__banner{background-color:var(--special-warning-surfaces-secondary)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"active":"CRWCUq__active","banner":"CRWCUq__banner","pill":"CRWCUq__pill","selectorPart":"CRWCUq__selectorPart"};
